var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProdRs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 61,
    viewBox: "0 0 70 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209",
    transform: "translate(-414 -443)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100",
    "data-name": "Rectangle 100",
    width: 70,
    height: 61,
    rx: 24,
    transform: "translate(414 443)",
    fill: "#f8f9fa"
  }), /*#__PURE__*/React.createElement("text", {
    id: "RS",
    transform: "translate(449 485)",
    fill: "#0057a6",
    fontSize: 32,
    fontFamily: "MyriadPro-Bold, Myriad Pro",
    fontWeight: 700,
    letterSpacing: "0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -18.928,
    y: 0
  }, "RS")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdRs);
export default __webpack_public_path__ + "static/media/prodRS.d6e607309cfe150b84647b67718d365f.svg";
export { ForwardRef as ReactComponent };